import staggerText from './initialStates/staggerText';
import picture from './initialStates/picture';

const initialState = new Map();

initialState.set('title', staggerText);
initialState.set('text', staggerText);
initialState.set('herotitle', staggerText);
initialState.set('herotext', staggerText);
initialState.set('picture', picture);
initialState.set('heropicture', picture);
initialState.set('sponsorLogo', picture);
initialState.set('tableitem', picture);

export default initialState;